var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12Z",
    fill: "#37427A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17.9102H19.5",
    stroke: "white",
    strokeWidth: 1.38095,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2853 17.9107V6.51786C13.2853 6.38051 13.2308 6.24879 13.1337 6.15168C13.0365 6.05456 12.9048 6 12.7675 6H6.5532C6.41585 6 6.28413 6.05456 6.18702 6.15168C6.0899 6.24879 6.03534 6.38051 6.03534 6.51786V17.9107",
    fill: "#37427A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2853 17.9107V6.51786C13.2853 6.38051 13.2308 6.24879 13.1337 6.15168C13.0365 6.05456 12.9048 6 12.7675 6H6.5532C6.41585 6 6.28413 6.05456 6.18702 6.15168C6.0899 6.24879 6.03534 6.38051 6.03534 6.51786V17.9107",
    stroke: "white",
    strokeWidth: 1.38095,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4639 17.9104V10.6604C18.4639 10.5231 18.4094 10.3914 18.3122 10.2943C18.2151 10.1971 18.0834 10.1426 17.9461 10.1426H13.2853",
    fill: "#37427A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4639 17.9104V10.6604C18.4639 10.5231 18.4094 10.3914 18.3122 10.2943C18.2151 10.1971 18.0834 10.1426 17.9461 10.1426H13.2853",
    stroke: "white",
    strokeWidth: 1.38095,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10675 8.58984H10.1782",
    stroke: "white",
    strokeWidth: 1.38095,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14246 12.7324H11.2139",
    stroke: "white",
    strokeWidth: 1.38095,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10675 15.3223H10.1782",
    stroke: "white",
    strokeWidth: 1.38095,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3568 15.3223H16.3925",
    stroke: "white",
    strokeWidth: 1.38095,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3568 12.7324H16.3925",
    stroke: "white",
    strokeWidth: 1.38095,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApart);
export default __webpack_public_path__ + "static/media/apart.096a28ef.svg";
export { ForwardRef as ReactComponent };